import { createTransform } from 'redux-persist';

import { type FooterInfos } from '../../apis/interventions/intervention.type';

// This transform is used to convert the pledgeDate to a Date object after getting it from the storage
export const pledgeDateTransform = createTransform(
  null,
  (outboundState: FooterInfos) => ({
    ...outboundState,
    pledgeDate: outboundState.pledgeDate ? new Date(outboundState.pledgeDate) : null,
  }),
  { whitelist: ['footer'] }
);
